












































import { Vue, Component, Prop, Watch, PropSync, Ref } from 'vue-property-decorator'
import { FindLojaUseCase } from '@/usecases'
import { Loja, Page, Pageable } from '@/models'
import axios, { CancelTokenSource } from 'axios'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'

@Component
export default class SeletorDeLojas extends Vue {
	@Ref() campo!: HTMLInputElement
	@PropSync('value') selecionado?: Loja | Loja[] | string | string[]
	@Prop({type: Array, default: () => []}) excludes!: string[]
	@Prop({ type: String }) idDaLojaSalva!: string | null
	@Prop({ type: String }) usuario?: string
	@Prop({ type: Boolean, default: false }) retornaObjetoLoja?: boolean
	@Prop({ type: Boolean, default: false }) listarLojasDoGrupoDoUsuario!: boolean
	@Prop({ type: Boolean, default: false }) autoPreecherComTodasAsLojas!: boolean
	@Prop({ type: String, default: null }) grupoEconomicoId!: string | null
	
	lojas: Loja[] = []
	busca: string | null = null
	findLojaUseCase = new FindLojaUseCase()
	cancelToken: CancelTokenSource | null = null
	selecionarIdUnico: string | null = null

	pageable: Pageable = {
		page: 0,
		size: 3,
	}
	
	pagina: Page<Loja> | null = null
	carregando = true

	created() {
		this.carregarSelecao()
	}

	@Watch('selecionado', { deep: true })
	onChangeSelecionado() {
		if(this.selecionado && typeof this.selecionado === 'object') {
			this.carregarSelecao()
		}	
	}

	extrairId(objeto: Loja | string): string {
		return typeof objeto === 'object'
			? objeto.id
			: objeto
	}

	async carregarSelecao() {
		if (!this.selecionado) {
			return await this.find()
		}

		// Objeto já carregado: só garante que está na lista para o autocomplete exibir
		if (typeof this.selecionado === 'object' && !Array.isArray(this.selecionado)) {
			const loja = this.selecionado as Loja
			if (!this.lojas.some(l => l.id === loja.id)) {
				this.lojas.push(loja)
			}
			this.carregando = false
			return
		}

		if (this.cancelToken) {
			this.cancelToken.cancel('Requisição anterior cancelada')
		}

		this.cancelToken = axios.CancelToken.source()
		const ids: string[] = Array.isArray(this.selecionado)
			? (this.selecionado as (string | Loja)[]).map(this.extrairId)
			: [this.extrairId(this.selecionado)]
		try {
			this.carregando = true

			const axiosConfig = {
				cancelToken: this.cancelToken.token,
			}

			this.pagina = await this.findLojaUseCase.find({
				ids,
				lojasDoGrupoDoUsuario: this.listarLojasDoGrupoDoUsuario,
			}, axiosConfig)
			this.pagina.content.forEach(loja => {
				this.lojas.push(loja)
			})
			
		} catch (error: any) {
			if (axios.isCancel(error)) return
			AlertModule.setError(error)
		} finally {
			this.carregando = false
		}
	}

	async find() {
		if (this.cancelToken) {
			this.cancelToken.cancel('Requisição anterior cancelada')
		}

		this.cancelToken = axios.CancelToken.source()
		try {
			this.carregando = true
			if (this.autoPreecherComTodasAsLojas) {
				let page = 0
				const todasAsLojas = [] as Loja[]
				let ultimaPagina = false
				do {
					this.pagina = await this.findLojaUseCase.find({
						page: page,
						size: this.pageable.size,
						lojasDoGrupoDoUsuario: this.listarLojasDoGrupoDoUsuario,
					}, {
						cancelToken: this.cancelToken.token,
					})

					Array.prototype.push.apply(todasAsLojas, this.pagina.content)

					page += 1
					ultimaPagina = this.pagina.last
				} while (!ultimaPagina)

				if (this.lojas.length === 0) {
					this.lojas = todasAsLojas

					this.$emit('input', todasAsLojas.map(loja => loja.id))
				}
			} else {
				if(this.grupoEconomicoId != null){
					this.pagina = await this.findLojaUseCase.findLojasByGrupoEconomicoId(
						this.grupoEconomicoId, 
						{cancelToken: this.cancelToken.token})
				}else {
					this.pagina = await this.findLojaUseCase.find({
						page: this.pageable.page || 0,
						size: this.pageable.size,
						busca: this.busca || undefined,
						lojasDoGrupoDoUsuario: this.listarLojasDoGrupoDoUsuario,
					}, {
						cancelToken: this.cancelToken.token,
					})}

				this.pagina.content.forEach(loja => {
					if (this.lojas.some(({ id }) => loja.id === id)) return
					this.lojas.push(loja)
					this.selecionarIdUnico = loja.id;
				})

				// Garante que a loja já selecionada permaneça na lista após o carregamento
				if (this.selecionado && typeof this.selecionado === 'object' && !Array.isArray(this.selecionado)) {
					const atual = this.selecionado as Loja
					if (!this.lojas.some(l => l.id === atual.id)) {
						this.lojas.unshift(atual)
					}
				}

				if (this.lojas.length < 2 && this.selecionarIdUnico && !(typeof this.selecionado === 'object' && !Array.isArray(this.selecionado))) {
					this.selecionado = ''
					this.$emit('input', this.retornaObjetoLoja ? this.lojas[0] : this.selecionarIdUnico)
				}
			}

		} catch (error: any) {
			if (axios.isCancel(error)) return
			this.pagina = null
			AlertModule.setError(error)
		} finally {
			this.carregando = false
		}
	}


	@Watch('busca', { deep: true })
	onChangeBusca(busca: string, buscaAnterior: string) {
		this.pageable = {
			...this.pageable,
			page: 0,
		}
		if (busca === buscaAnterior) {
			this.carregando = false
			return
		}
		this.find()
	}

	async pageNext() {
		this.pageable.page = !this.pageable.page
			? 1
			: this.pageable.page += 1

		await this.find()
	}

	get lojasFiltradas() {
		return this.lojas
	}

	get carregouTodosAsLojas() {
		return this.pagina?.last || false
	}

	get noDataMessage() {
		if (this.carregando) {
			return 'Carregando...'
		}
		if (!this.busca) {
			return 'Digite para consultar...'
		}
		return '$vuetify.noDataText'
	}

	focus() {
		this.campo.focus()
	}

	limparLojas() {
		this.lojas = [] 
	}

	@Watch('grupoEconomicoId', { immediate: true })
	onGrupoEconomicoChange() {
		this.limparLojas()
		this.find() 
	}

}
